import {Badge, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown} from 'reactstrap';
import ConfirmationModalCallBack from '../../../../components/nominex/ConfirmationModalCallBack';
import NotificationView from '../../../../views/pages/notifications/NotificationView';
import {DEFAULT_GRAPHQL_POLL_INTERVAL} from '../../../../services/configs/constants';
import default_avatar from '../../../../assets/img/icons/default_avatar.jpg';
import UseNotifications from '../../../../components/nominex/Notifications';
import {useNQuery} from '../../../../services/decorators/apolloGraphQL';
import {store} from '../../../../services/redux/storeConfig/store';
import UseTokens from '../../../../components/nominex/Tokens';
import {history} from '../../../../services/helpers/history';
import UseIcon from '../../../../components/nominex/useIcon';
import TokenView from '../../../pages/tokens/TokenView';
import React, {useEffect, useState} from 'react';
import * as Icon from 'react-feather';
import {connect} from 'react-redux';
import {gql} from '@apollo/client';

const mapStateToProps = (state) => {
    return {
        session: state.auth.session.data,
        user: state.auth.session.data.role_slug,
        permission: state.auth.session.data.permissions,
    };
};

const UserDropdown = (props) => {
    return (
        <DropdownMenu right>
            <DropdownItem tag="a" href="#" onClick={(e) => history.push("/auth/login")}>
                <Icon.Power size={14} className="mr-50"/>
                <span className="align-middle">Salir</span>
            </DropdownItem>
        </DropdownMenu>
    );
};

const UserWidget = (props = {}) => {
    //Consts&states
    const [notificationsProps, setNotificationsProps] = useState({
        numberNotificationsNoReaded: 0,
        showNotifications: false,
    });
    const [tokensProps, setTokensProps] = useState({
        numberTokensPending: 0,
        showTokens: false,
    });
    const [confirmationModal, setConfirmationModal] = useState({
        noFooter: false,
        isOpen: false,
        data: null,
        title: "",
        text: "",
        ref: "",
    });
    const userId = store.getState().auth.session.data.user_id;

    //queries&mutations
    const GET_NOTIFICATIONS = {
        query: gql`
            query{
                responseQuery: obtenerNotificaciones(
                    where:{
                        destinatarioId:{is:"${userId}"}
                        leida:{is:"false"}
                    }
                ){
                    items{
                        id
                    }
                }
            }
        `
    };
    const GET_TOKENS = {
        query: gql`
            query{
                responseQuery: obtenerTokensDictaminador(
                    filtros:{estatus: PENDIENTE}
                ){
                    id
                }
            }
        `
    };

    //useQueries&useMutations
    const {
        runQuery: executeQueryNotifications,
        data: dataNotifications,
        loading: loadingNotifications,
        error: errorNotifications,
        refetch: refetchNotifications,
    } = useNQuery(GET_NOTIFICATIONS, {pollInterval: DEFAULT_GRAPHQL_POLL_INTERVAL});
    const {
        runQuery: executeQueryTokens,
        data: dataTokens,
        loading: loadingTokens,
        error: errorTokens,
        refetch: refetchTokens,
    } = useNQuery(GET_TOKENS, {pollInterval: DEFAULT_GRAPHQL_POLL_INTERVAL});

    //effects
    useEffect(() => {
        executeQueryNotifications().then();
        executeQueryTokens().then();
    }, []);

    useEffect(() => {
        if (dataNotifications) {
            let notificationsPropsClone = {...notificationsProps};
            notificationsPropsClone.numberNotificationsNoReaded = dataNotifications?.responseQuery?.items?.length > 0 ? dataNotifications.responseQuery.items.length : 0;
            setNotificationsProps(notificationsPropsClone);
        }
    }, [dataNotifications, loadingNotifications, errorNotifications]);

    useEffect(() => {
        if (dataTokens) {
            let tokensPropsClone = {...tokensProps};
            tokensPropsClone.numberTokensPending = dataTokens?.responseQuery?.length > 0 ? dataTokens.responseQuery.length : 0;
            setTokensProps(tokensPropsClone);
        }
    }, [dataTokens, loadingTokens, errorTokens]);

    //handleFunctions
    const handleToggleNotifications = () => {
        let notificationsPropsClone = {...notificationsProps};
        notificationsPropsClone.showNotifications = !notificationsPropsClone.showNotifications;
        setNotificationsProps(notificationsPropsClone);
    }

    const handleSuccessMarkAllAsRead = () => {
        refetchNotifications().then();
    }

    const handleShowNotification = (props = {}) => {
        const {id, titulo} = props;
        setConfirmationModal({
            ref: id,
            isOpen: true,
            title: titulo,
            noFooter: true,
            text: <NotificationView id={id}/>,
            data: {action: 'show_notification'},
        });
    }

    const handleToggleTokens = () => {
        let tokensPropsClone = {...tokensProps};
        tokensPropsClone.showTokens = !tokensPropsClone.showTokens;
        setTokensProps(tokensPropsClone);
    }

    const handleChangeTokenStatus = (props = {}) => {
        const {id, title, text, mutation} = props;
        setConfirmationModal({
            ref: id,
            text: text,
            title: title,
            isOpen: true,
            noFooter: false,
            data: {action: 'token_status', mutation: mutation},
        });
    }

    const handleShowToken = (props = {}) => {
        const {id, titulo} = props;
        setConfirmationModal({
            ref: id,
            isOpen: true,
            title: titulo,
            noFooter: true,
            text: <TokenView id={id}/>,
        });
    }

    const handleModal = async (actionModal) => {
        setConfirmationModal({...confirmationModal, isOpen: false});
        if (actionModal && actionModal === 'accept') {
            const {action, mutation} = confirmationModal.data;
            switch (action) {
                case 'token_status':
                    await mutation().then();
                    refetchTokens().then();
                    break;
                case 'show_notification':
                    refetchNotifications().then();
                    break;
            }
        }
    }

    //arrangeData

    //renders
    return (
        <>
            <ul className="nav navbar-nav navbar-nav-user float-right">
                <UncontrolledDropdown tag="li" className="dropdown-notification nav-item" onToggle={handleToggleTokens}>
                    <DropdownToggle tag="a" className="nav-link nav-link-label">
                        <UseIcon name="key" size={21}/>
                        {tokensProps?.numberTokensPending > 0 && (
                            <Badge pill color="primary" className="badge-up">
                                {` ${tokensProps.numberTokensPending} `}
                            </Badge>
                        )}
                    </DropdownToggle>
                    <DropdownMenu tag="ul" right className="dropdown-menu-media">
                        <li className="dropdown-menu-header">
                            <div className="dropdown-header mt-0">
                                <h3 className="text-white">{` ${tokensProps.numberTokensPending} Nuevo${tokensProps.numberTokensPending > 1 ? 's' : ''}`}</h3>
                                <span className="notification-title">{`Token${tokensProps.numberTokensPending > 1 ? 's' : ''} de Autorización Nominex`}</span>
                            </div>
                        </li>
                        {tokensProps?.showTokens && (
                            <UseTokens handleChangeTokenStatus={handleChangeTokenStatus}
                                       handleShowToken={handleShowToken}/>
                        )}
                    </DropdownMenu>
                </UncontrolledDropdown>

                <UncontrolledDropdown tag="li" className="dropdown-notification nav-item" onToggle={handleToggleNotifications}>
                    <DropdownToggle tag="a" className="nav-link nav-link-label">
                        <UseIcon name="bell" size={21}/>
                        {notificationsProps?.numberNotificationsNoReaded > 0 && (
                            <Badge pill color="primary" className="badge-up">
                                {` ${notificationsProps.numberNotificationsNoReaded} `}
                            </Badge>
                        )}
                    </DropdownToggle>
                    <DropdownMenu tag="ul" right className="dropdown-menu-media">
                        <li className="dropdown-menu-header">
                            <div className="dropdown-header mt-0">
                                <h3 className="text-white">{` ${notificationsProps.numberNotificationsNoReaded} Nueva${notificationsProps.numberNotificationsNoReaded > 1 ? 's' : ''}`}</h3>
                                <span
                                    className="notification-title">{`Notificaci${notificationsProps.numberNotificationsNoReaded > 1 ? 'ones' : 'ón'} Nominex`}</span>
                            </div>
                        </li>
                        {notificationsProps?.showNotifications && (
                            <UseNotifications handleSuccessMarkAllAsRead={handleSuccessMarkAllAsRead}
                                              handleShowNotification={handleShowNotification}/>
                        )}
                    </DropdownMenu>
                </UncontrolledDropdown>

                <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
                    <DropdownToggle tag="a" className="nav-link dropdown-user-link">
                        <div className="user-nav d-sm-flex d-none">
							<span className="user-name text-bold-600">
								{props.session.name}
							</span>
                            <span className="user-status">{props.session.role}</span>
                        </div>
                        <span data-tour="user">
							<img
                                src={props.session.avatar ? props.session.avatar : default_avatar}
                                className="round cover"
                                alt="avatar"
                                height="40"
                                width="40"
                            />
						</span>
                    </DropdownToggle>
                    <UserDropdown {...props} />
                </UncontrolledDropdown>
            </ul>
            <ConfirmationModalCallBack
                handleModal={(actionModal) => handleModal(actionModal)}
                title={confirmationModal.title}
                isOpen={confirmationModal.isOpen}
                children={confirmationModal.text}
                noFotter={confirmationModal.noFooter}
            />
        </>
    );
};

const NavbarUser = connect(mapStateToProps)(UserWidget);

export default NavbarUser;
